
import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, Col, Container, Nav, NavItem, Row, NavLink, TabContent, TabPane, CardText, Form, Label, Input, FormFeedback } from "reactstrap";
import Breadcrumb from "Components/Common/Breadcrumb";
import classnames from "classnames";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import Dropzone from "react-dropzone"
import { useParams } from 'react-router-dom';
import { useCommonDataFindAllQuery, useGlacierFindAllQuery, useGlacierUpdateMutation } from "store";
import MainMap from "Components/MainMap/Index";
import voyager from '../../../assets/images/map/voyager.png';
import google from '../../../assets/images/map/google.jpg';
import topo from '../../../assets/images/map/topo.jpg';
import openstreet from '../../../assets/images/map/openstreet.jpg';
import Measurement from "./Measurement";
import Labrator from "./Labrator";
import UsageIndex from "Components/Usage/Index";
import SafetyIndex from "Components/Safety/Index";
import OwnerIndex from "Components/Owner/Index";
import Switch from "react-switch";
import ShapeUpload from "Components/fileUpload/ShapeUpload";
import toastr from "toastr";


const SwIceRiverShow = () => {

  const { id } = useParams();

  const [activeTab, setactiveTab] = useState("1");
  const [baseMap, setBaseMap] = useState("voyager")
  const { data, error, isFetching } = useGlacierFindAllQuery(`/${id}`);
  const [glacierMainData, setGlacierMainData] = useState<any>();
  const [glacierGeom, setGlacierGeom] = useState<any>();
  const [customCenter, setCustomCenter] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  const [glacierUpdate, glacierUpdateResult] = useGlacierUpdateMutation();

  const [saveBorder, setSaveBorder] = useState<boolean>(false);

  const {
    data: commonSpring,
    error: commonSpringError,
    isFetching: isCommonSpringFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmd_glacier_type`);

  useEffect(() => {
    setGlacierMainData(data?.data)
    const tempSaveBorder = glacierMainData !== null ? glacierMainData?.save_border : false;
    setSaveBorder(tempSaveBorder)
    setGlacierGeom(glacierMainData?.geom)
    const tempCenter = { cusCenter: glacierGeom?.coordinates?.[0]?.[0]?.[0] };
    setCustomCenter(tempCenter);
  }, [glacierGeom, glacierMainData, data])

  const toggle = (tab: any) => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: glacierMainData?.id,
      code: glacierMainData?.code,
      name: glacierMainData?.name,
      cmd_glacier_type: glacierMainData?.cmd_glacier_type,
      save_border_desicion: glacierMainData?.save_border_desicion,
      save_border: saveBorder === undefined ? false : saveBorder,
      child_info: glacierMainData?.child_info,
      location: glacierMainData?.location,

      au1_name: glacierMainData?.au1_name,
      au2_name: glacierMainData?.au2_name,
      latitude: glacierMainData?.latitude,
      longitude: glacierMainData?.longitude,
      elevation: glacierMainData?.elevation,

    },
    validationSchema: Yup.object({
      // code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      // name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      // cmd_glacier_type: Yup.string().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      // location: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      // save_border_desicion: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      // child_info: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      const formData = new FormData();
      formData.append('id', glacierMainData ? glacierMainData.id.toString() : '0');
      formData.append('code', values?.code);
      formData.append('name', values?.name);
      formData.append('child_info', values?.child_info);
      formData.append('cmd_glacier_type', values?.cmd_glacier_type);
      formData.append('location', values?.location);
      formData.append('save_border', String(saveBorder ?? false));
      formData.append('save_border_desicion', values?.save_border_desicion);

      if (selectedFiles !== null && selectedFiles && selectedFiles.length > 0) {
        selectedFiles.forEach((file: File, index: number) => {
          formData.append(`shapes`, file);
        });
      }
      glacierUpdate(formData)
        .unwrap()
        .then((response) => {
          toastr.success("Мэдээлэл амжилттай засагдлаа!", "Амжилттай");
        })
        .catch((error) => {
          toastr.error("Мэдээлэл амжилтгүй!", "Амжилтгүй");
        })
      validation.resetForm();
      setResetFiles(true);
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Гадаргын ус" breadcrumbItem="Мөсөн гол" />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>

                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "1",
                        })}
                        onClick={() => {
                          toggle("1");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                        <span className="d-none d-sm-block">Үндсэн бүртгэл</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "2",
                        })}
                        onClick={() => {
                          toggle("2");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                        <span className="d-none d-sm-block">Хэмжилт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "3",
                        })}
                        onClick={() => {
                          toggle("3");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                        <span className="d-none d-sm-block">Шинжилгээ</span>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "4",
                        })}
                        onClick={() => {
                          toggle("4");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Ашиглалт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "5",
                        })}
                        onClick={() => {
                          toggle("5");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Хамгаалалт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "6",
                        })}
                        onClick={() => {
                          toggle("6");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Эзэмшигч</span>
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab} className="px-3 pt-3 text-muted">
                    <TabPane tabId="1">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">Мөстөл, мөсөн голын бүртгэлийн дугаар *</Label>
                              <Input
                                name="code"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.code || ""}
                                invalid={
                                  validation.touched.code &&
                                    validation.errors.code
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.code &&
                                validation.errors.code ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.code}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Мөстөл, мөсөн голын байршил *</Label>
                              <Input
                                name="location"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.location || ""}
                                invalid={
                                  validation.touched.location && validation.errors.location
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.location && validation.errors.location ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.location}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label >Аймаг, нийслэл</Label>
                              <Input
                                name="au1_name"
                                disabled
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au1_name || ""}
                                invalid={
                                  validation.touched.au1_name && validation.errors.au1_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au1_name && validation.errors.au1_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au1_name}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label >Солбицол У</Label>
                              <Input
                                disabled
                                name="longitude"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.longitude || ""}
                                invalid={
                                  validation.touched.longitude && validation.errors.longitude
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.longitude && validation.errors.longitude ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.longitude}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">	Мөсөн голын төрөл *</Label>
                              <Input
                                name="cmd_glacier_type"
                                type="select"
                                className="form-select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.cmd_glacier_type || ""}
                                invalid={
                                  validation.touched.cmd_glacier_type &&
                                    validation.errors.cmd_glacier_type
                                    ? true
                                    : false
                                }
                              >
                                <option disabled value="">Сонгох</option>
                                {commonSpring?.data?.map((item, index) => (
                                  <option value={item?.id}>{item?.name}</option>
                                ))}

                              </Input>
                              {validation.touched.cmd_glacier_type &&
                                validation.errors.cmd_glacier_type ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.cmd_glacier_type}
                                </FormFeedback>
                              ) : null}

                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Хамгаалалтын бүстэй эсэх*</Label> <br />
                              <Switch
                                uncheckedIcon={<Offsymbol />}
                                checkedIcon={<OnSymbol />}
                                className="me-1 mb-sm-8 mb-2 ms-3"
                                onColor="#626ed4"
                                onChange={() => {
                                  setSaveBorder(!saveBorder);
                                }}
                                checked={saveBorder}
                              />
                            </div>

                            <div className="mb-3">
                              <Label>Сум, дүүрэг</Label>
                              <Input
                                disabled
                                name="au2_name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au2_name || ""}
                                invalid={
                                  validation.touched.au2_name && validation.errors.au2_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au2_name && validation.errors.au2_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au2_name}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label >Өндөршилт, Z</Label>
                              <Input
                                disabled
                                name="elevation"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.elevation || ""}
                                invalid={
                                  validation.touched.elevation && validation.errors.elevation
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.elevation && validation.errors.elevation ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.elevation}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">Мөстөл, мөсөн голын нэр *</Label>
                              <Input
                                name="name"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.name || ""}
                                invalid={
                                  validation.touched.name && validation.errors.name
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.name && validation.errors.name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.name}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Хамгаалалтын бүсийн шийдвэр *</Label>
                              <Input
                                name="save_border_desicion"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.save_border_desicion || ""}
                                invalid={
                                  validation.touched.save_border_desicion && validation.errors.save_border_desicion
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.save_border_desicion && validation.errors.save_border_desicion ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.save_border_desicion}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Мөстөл, мөсөн голоос эх авсан гол, горхи *</Label>
                              <Input
                                name="child_info"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.child_info || ""}
                                invalid={
                                  validation.touched.child_info && validation.errors.child_info
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.child_info && validation.errors.child_info ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.child_info}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label >Солбицол Х</Label>
                              <Input
                                disabled
                                name="latitude"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.latitude || ""}
                                invalid={
                                  validation.touched.latitude && validation.errors.latitude
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.latitude && validation.errors.latitude ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.latitude}
                                </FormFeedback>
                              ) : null}
                            </div>

                          </Col>

                          <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} fileType={'multipolygon'} />
                        </Row>
                        {
                          (glacierGeom) && (
                            <Row>
                              <Col lg={12}>
                                <div className='mapTypeSelection'>
                                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                                </div>
                                <MainMap baseMap={baseMap} results={glacierGeom} customCenter={customCenter} zoomChange={11} type="" />
                              </Col>

                            </Row>
                          )
                        }

                        <Row>
                          <Col lg={12} className="d-flex justify-content-center mt-3">
                            <button type="submit" className="btn btn-primary"> Хадгалах </button>
                          </Col>
                        </Row>
                      </Form>

                    </TabPane>
                    <TabPane tabId="2">
                      <Measurement />
                    </TabPane>
                    <TabPane tabId="3">
                      <Labrator />
                    </TabPane>
                    <TabPane tabId="4">
                      <UsageIndex id={id} table_name={'glacier'} />
                    </TabPane>
                    <TabPane tabId="5">
                      <SafetyIndex id={id} table_name={'glacier'} />
                    </TabPane>
                    <TabPane tabId="6">
                      <OwnerIndex id={id} table_name={'glacier'} />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>


          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SwIceRiverShow;